<template>
  <div class="footer">
    <footer class="page-footer">
      <div class="footer_main">
        <div class="logo">
          <img class="logo_footer" src="../assets/img/logo_nav.png" alt="">
        </div>
        <div>
          <h5 class="txt_p" style="margin-top:.5rem">
            <font-awesome-icon class="icon" icon="map-marker-alt"/>
             Endereço
          </h5>
          <p class="txt_p" style="margin-top:.5rem"> Santos </p>
          <p class="txt_p" style="margin-top:.5rem"> Avenida Conselheiro Nébias, 754 </p>
          <p class="txt_p" style="margin-top:.5rem"> Sala 1704 <br> Helbor Office, Boqueirão</p>
        </div>
        <div>
          <h5 id="fale_conosco"><a class="fale_conosco">Fale conosco</a>
          </h5>
          
          <p class="txt_p">
            <strong class="ul_title">Pedagógico:</strong>
            <ul class="ul_tel">

              <li><p class="txt_p"> (13) 3877-0073 </p></li>

              <li><p class="txt_p"> (13) 99639-2735 </p></li>

              <li>
                <a href="https://wa.me/5513997499702" class="wpplink" target="_blank" style="color:white;" title="Clique para iniciar uma conversa no Whatsapp">
                <font-awesome-icon class="icon" :icon="['fab','whatsapp']" style="color:gray"/>
                  (13) 99749-9702
                </a>
              </li>
            
            </ul>
          </p>
          <p class="txt_p">
            <strong class="ul_title">Financeiro:</strong>
            <ul class="ul_tel">

              <li><p class="txt_p"> (13) 3223-7154 </p></li>

              <li><p class="txt_p"> (13) 99767-2201 </p></li>
            
            </ul>
          </p>
          <!-- <p class="txt_p">
            <strong style="display:inline-block;vertical-align:top">Financeiro:</strong>
            <ul style="display:inline-block">

              <li><p class="txt_p"> (13) 3223-7154 </p></li>

              <li><p class="txt_p"> (13) 99767-2201 </p></li>
            
            </ul>
          </p> -->
          <!-- <p class="txt_p">
            <a href="https://wa.me/5511974402201" class="wpplink" target="_blank" style="color:white;" title="Clique para iniciar uma conversa no Whatsapp">
              <font-awesome-icon class="icon" :icon="['fab','whatsapp']" style="color:gray"/>
              (11) 97440.2201
            </a>
          </p> -->
          <p class="txt_p">
            <font-awesome-icon class="icon" icon="envelope"/>
            contato@cursinhosapiencia.com.br
          </p>


        </div>
        <div style="margin-top: 10px;">

          <div id="fb">
            <div class="fb-page"
              data-href="https://www.facebook.com/cursinhosapiencia/"
              data-width="380"
              data-hide-cover="false"
              data-show-facepile="false">
            </div>
          </div>
          <p class="txt_p">
            <font-awesome-icon class="icon" :icon="['fab','facebook']" style="color:gray"/>
            Cursinho Sapiência
          </p>
          <p class="txt_p">
            <font-awesome-icon class="icon" :icon="['fab','instagram']" style="color:gray"/>
            @cursinhosapiencia
          </p>

        </div>
      </div>
      <div class="footer-copyright">
        <div class="container txt_p">
          Desenvolvido por <a class="link_footer" href="http://flipfloplab.com/">Flipflop Lab</a> v 2.0.7
        </div>
      </div>
    </footer>
  </div>
</template>

<script>

    (function(d){
    	const b = d.body;
    	const p = d.createElement('script');
    	p.type = 'text/javascript';
    	p.setAttribute('charset','utf-8');
    	p.async = 1;
    	p.id = "flychat";
    	window.FC_DOMAIN = "sapiencia";
    	p.src = "https://api.flychats.com.br/widget/flychat_widget.js";
    	p.defer = true;
    	b.appendChild(p);
    }(document));
/*
 (function(d){
    var b = d.body;
    var s = d.getElementsByTagName('script'), p = d.createElement('script');
    window.WidgetId = "FC_WIDGET";
    p.type = 'text/javascript';
    p.setAttribute('charset','utf-8');
    p.async = 1;
    p.id = "flychat";
    p.src = "https://sapiencia.flychats.com.br//widget/flychat_widget.js";
    b.appendChild(p);
    //document.getElementById('FC_flychat_chat_iframe').style.height='40px';
  }(document));*/
</script>

<style media="screen">
  footer{
    background:#7435af;
  }
  #fale_conosco{
    color: white;
    text-align: center;
  }
  .logo_footer {
    background: white;
    padding: 30px;
    margin-top: 4%;
    border-radius: 40px;
  }
  .txt_footer{
    color:white;
    font-size: 13px;
  }
  .txt_p{
    color:white;
    margin:0
  }
  .footer_main{
    padding-top: 10px;
    display: flex;
    justify-content: space-around;
    /* align-items: center; */
  }
  .container{

  }
  .link_footer{
    color: #fffa00;
    text-decoration: none;
    background-color: transparent;
  }
  .link_footer:hover{
    color: #808080;
    text-decoration: none;
    background-color: transparent;
  }
  .ul_tel {
    display: inline-block;
    width:65%;
  }
  .ul_tel li {
    text-align: left;
  }
  .ul_title {
    display:inline-block;
    vertical-align:top;
    width: 35%;
  }
  @media only screen and (max-width: 800px) {
    .footer_main{
      display: block;
    }
    .logo {
      justify-content: center;
      display: flex;
      width: 100%;
    }
    .txt_p{
    }
    .ul_tel li {
      text-align: center;
    }
  }
</style>
